/* eslint-disable @typescript-eslint/no-explicit-any */
import _ from 'lodash';
import moment from 'moment';
import React, { useEffect } from 'react';
import { announcementService } from '../../api/services/announcementService';
import {
  setEmpAnnounceData,
  setEmpAnnounceDataLoader,
} from '../../infra/aggregates/announcement/announcementSlice';
import { useAppDispatch, useAppSelector } from '../../infra/hooks';
import { useTranslation } from 'react-i18next';
import {
  baseDateFormatting,
  baseTimeFormatting,
  convertUtcToDate,
} from '../../common/helper';
interface PropsValues {
  setAnnouncementData: (data: any) => void;
  settextFilter: any;
}

function DTOAnnouncement({ setAnnouncementData, settextFilter }: PropsValues) {
  const { t } = useTranslation();
  const selector = useAppSelector((state) => state.authSlice);
  const dispatch = useAppDispatch();
  async function getAnnouncementList(companyId: number, empId: number) {
    dispatch(setEmpAnnounceDataLoader(true));
    const response: any = await announcementService.getannouncementList(
      empId,
      companyId,
    );
    if (response.response == 'success') {
      dispatch(setEmpAnnounceData(response.data));

      const filtered_list: any = _.filter(response?.data, (data: any) => {
        return data?.status == 1;
      });
      const annList = () => {
        if (settextFilter.length) {
          const txt = settextFilter.toLowerCase();
          const res = _.filter(filtered_list, function (e: any) {
            return e.subject?.toLowerCase().includes(txt);
          });
          {
            return res;
          }
        } else {
          return filtered_list;
        }
      };

      const announceDataList: any = _.map(annList(), (data: any) => {
        const today: any = moment(new Date()).format(baseDateFormatting);
        const AnnounceDate: any = convertUtcToDate(
          data?.created_at,
          baseDateFormatting,
        );

        const timeView = data
          ? convertUtcToDate(data?.created_at, baseTimeFormatting)
          : '';

        let anDate: any = `${t('Today')}` + ' , ' + timeView;
        if (AnnounceDate != today) {
          anDate = AnnounceDate + ' , ' + timeView;
        }

        const rowData: any = {
          id: data?.id,
          date: anDate,
          content: data?.subject,
          message: data?.message,
          attachment: data?.attachment,
          status: data?.status,
          subject: data?.subject,
        };
        return rowData;
      });

      setAnnouncementData(announceDataList);
      dispatch(setEmpAnnounceDataLoader(false));
    } else {
      dispatch(setEmpAnnounceDataLoader(false));

      return;
    }
  }
  useEffect(() => {
    if (selector.emp_id && selector.company_id)
      getAnnouncementList(selector.emp_id, selector.company_id);
  }, []);

  useEffect(() => {
    getAnnouncementList(selector.emp_id, selector.company_id);
  }, [settextFilter.length]);
  return <></>;
}
export default DTOAnnouncement;
